<template>
    <div class="email-receipt-container">
        <div v-if="receiptType === 'email'">
            <div class="has-text-centered">
                <div class="columns is-centered">
                    <div class="column is-6">
                        <template v-if="!emailSent && !receiptLoader">
                            <p class="is-size-5"> Please enter an email and we'll send you a copy of your receipt</p>
                            <div class="field">
                                <div class=" has-text-centered">
                                    <input 
                                        autofocus
                                        class="input is-hovered email-input text-input" 
                                        type="email" 
                                        placeholder="yo@aol.com"
                                        v-model="email">
                                    <BaseButton  
                                        title="Send Receipt"
                                        :classNames="['button--modifier', 'send-btn']"
                                        @click="sendReceipt"
                                    />
                                </div>
                            </div>
                        </template>

                        <BaseLoader v-if="receiptLoader" type="menu"/>
                        <template v-if="emailSent">
                            <p class="is-size-5">A copy of your receipt has successfully been sent to {{email}}</p>
                        </template>
                    </div>
                </div>
            </div>
            {{msg}}
        </div>

        <div v-else-if="receiptType === 'SMS'" class="has-text-centered">
            <p class="is-size-1">😊</p>
            <p class="is-size-5">{{msg}}</p>
        </div>
    </div>
</template>


<script>
import orderService from "@/services/order.service";

import { SUCCESS_MSG } from '@/common/messages/success.msg';
import { ERROR_MSG } from '@/common/messages/error.msg';
export default {
    props: {
        orderId: {
            type: String,
            default: ""
        },
        lb: {
            type: String,
            default: ""
        },
        receiptType: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            email: "",
            emailSent: false,
            msg: "",
            receiptLoader: false
        };
    },
    methods: {
        sendReceipt() {
            this.receiptLoader = true;
            if (!this.email) {
                this.msg = ERROR_MSG.COMMON.MISSING_FIELDS;
                this.receiptLoader = false;
            } else {
                this.msg = "";
                orderService
                    .emailOrderReceipt(this.orderId, this.lb, this.email)
                    .then(res => {
                        this.receiptLoader = false;
                        if (res.data.message ===  SUCCESS_MSG.ORDER.EMAIL_RECEIPT) {
                            this.emailSent = true;
                            let self = this;
                            // reset modal
                            setTimeout(function() {
                                self.$modal.hide("contentModal");
                                self.emailSent = false;
                            }, 2500);
                        } else {
                            this.msg = unexpectedErr;
                        }
                    })
                    .catch(err => {
                        this.receiptLoader = false;
                        this.msg = unexpectedErr;
                    });
            }
        },
                // smsReceipt() {
        //     orderService.smsOrderReceipt(this.orderId, this.lb)
        //         .then((res) => {
        //             console.log(res);  
        //         })
        //         .catch((err) => {
        //             console.log(err);
        //         });
        // },
    }
};
</script>

<style lang="scss">
@import "globalStyles";

.email-input {
    margin: 1.5em 0em;
}

.email-receipt-container {
    padding-top: 2em;
}

</style>




// WEBPACK FOOTER //
// src/components/checkout/EmailReceipt.vue